__turbopack_context__.v({
  "extra-options-title": "ProductsSummary-module-scss-module__J7mDAq__extra-options-title",
  "list": "ProductsSummary-module-scss-module__J7mDAq__list",
  "product": "ProductsSummary-module-scss-module__J7mDAq__product",
  "product-footer": "ProductsSummary-module-scss-module__J7mDAq__product-footer",
  "product-header": "ProductsSummary-module-scss-module__J7mDAq__product-header",
  "product-list": "ProductsSummary-module-scss-module__J7mDAq__product-list",
  "with-tooltip": "ProductsSummary-module-scss-module__J7mDAq__with-tooltip",
});
